<template>
    <div>
       
    </div>
</template>

<script>
  export default {
      props: ['dateFormat'],
   mounted() {
        var self = this;
        $(this.$el).datepicker({
            dateFormat: this.dateFormat,
            onSelect: function(date) {
               self.$emit('update-date', date);
            }
        }); 
   },
   beforeDestroy(){
          $(this.$el).datepicker('hide').datepicker('destroy');
   },
 }
</script>




// WEBPACK FOOTER //
// src/components/JQueryPluggins/DatePicker.vue